import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center",
    "color": "black",
    "margin-bottom": "30px"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "loginTab"
};
const _hoisted_3 = {
  style: {
    "padding": "0 30px",
    "box-sizing": "border-box",
    "margin": "30px 0"
  }
};
const _hoisted_4 = {
  key: 2,
  style: {
    "text-align": "center",
    "cursor": "pointer"
  }
};
const _hoisted_5 = {
  key: 0,
  style: {
    "color": "#A5A5A5"
  }
};
const _hoisted_6 = {
  key: 3,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "font-size": "12px",
    "color": "#43A1AE",
    "padding": "0 20px",
    "cursor": "pointer"
  }
};
const _hoisted_7 = {
  style: {
    "width": "100%",
    "height": "40px",
    "text-align": "center",
    "background": "#E7E7E7",
    "line-height": "40px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.popupShow,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.popupShow = $event),
    width: "20%",
    "align-center": "",
    style: {
      "border-radius": "10px",
      "overflow": "hidden",
      "min-width": "380px"
    },
    "before-close": _ctx.handleClose
  }, _createSlots({
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h1", null, _toDisplayString(_ctx.title[_ctx.popupState]), 1)]), _ctx.popupState == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.modifyLoginState(0)),
      style: _normalizeStyle('color:' + (_ctx.loginState == 0 ? '#000;' : 'A5A5A5;') + 'border-bottom:' + (_ctx.loginState == 0 ? '2px solid #000;' : 'none'))
    }, _cache[12] || (_cache[12] = [_createElementVNode("span", null, "账号登录", -1)]), 4), _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.modifyLoginState(1)),
      style: _normalizeStyle('color:' + (_ctx.loginState == 1 ? '#000;' : 'A5A5A5;') + 'border-bottom:' + (_ctx.loginState == 1 ? '2px solid #000;' : 'none'))
    }, _cache[13] || (_cache[13] = [_createElementVNode("span", null, "短信登录", -1)]), 4)])) : _createCommentVNode("", true), _createVNode(_component_el_form, {
      "label-position": "left",
      "label-width": "60px",
      style: {
        "padding": "0 20px",
        "box-sizing": "border-box"
      },
      onKeypress: _ctx.next
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "手机号",
        prop: "phone"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "可用于登录或找回密码",
          modelValue: _ctx.formData.phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.formData.phone = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _ctx.popupState == 0 || _ctx.popupState == 2 || _ctx.loginState == 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: (_ctx.popupState == 2 ? '新' : '') + '密码'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "请设置登录密码",
          type: "password",
          modelValue: _ctx.formData.password,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.formData.password = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), _ctx.popupState == 0 || _ctx.popupState == 2 || _ctx.loginState == 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: "验证码"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入验证码",
            modelValue: _ctx.formData.captcha,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.formData.captcha = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            plain: "",
            onClick: _ctx.get_code,
            disabled: _ctx.clock != 60
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.get_code_text), 1)]),
            _: 1
          }, 8, ["onClick", "disabled"])]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["onKeypress"]), _ctx.loginState == 0 && _ctx.popupState == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      style: {
        "text-align": "right",
        "padding": "0 20px",
        "font-size": "13px",
        "cursor": "pointer"
      },
      onClick: _cache[5] || (_cache[5] = $event => _ctx.modifyShowState(2))
    }, _cache[14] || (_cache[14] = [_createElementVNode("span", null, "忘记密码", -1)]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      color: "#12A4BE",
      round: "",
      style: {
        "width": "100%",
        "height": "40px"
      },
      onClick: _ctx.pushForm
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.btnText[_ctx.popupState]), 1)]),
      _: 1
    }, 8, ["onClick"])]), _ctx.popupState != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_ctx.popupState == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_cache[15] || (_cache[15] = _createTextVNode("已有账号？", -1)), _createElementVNode("span", {
      style: {
        "color": "#43A1AE"
      },
      onClick: _cache[6] || (_cache[6] = $event => _ctx.modifyShowState(1))
    }, "去登录")])) : (_openBlock(), _createElementBlock("span", {
      key: 1,
      style: {
        "color": "#43A1AE"
      },
      onClick: _cache[7] || (_cache[7] = $event => _ctx.modifyShowState(0))
    }, "新用户账号注册"))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", {
      onClick: _cache[8] || (_cache[8] = $event => _ctx.modifyShowState(1))
    }, "登录已有账号"), _createElementVNode("span", {
      onClick: _cache[9] || (_cache[9] = $event => _ctx.modifyShowState(0))
    }, "新用户账号注册")]))]),
    _: 2
  }, [_ctx.popupState != 2 ? {
    name: "footer",
    fn: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, [_cache[16] || (_cache[16] = _createTextVNode("登录即表示您已阅读并同意", -1)), _createElementVNode("a", {
      style: {
        "color": "#43A1AE",
        "cursor": "pointer"
      },
      onClick: _cache[10] || (_cache[10] = (...args) => _ctx.open && _ctx.open(...args))
    }, "隐私政策")])])]),
    key: "0"
  } : undefined]), 1032, ["modelValue", "before-close"])]);
}